import { PaginationReturn } from '@common/types/service';
import { useAllPublicEventsQuery, useGetLanguageSpokenOptionsQuery, usePrefetch } from '@event/services/events';
import { RegistrationEventListItem } from '@event/types/event';
import { OverviewEventCard } from '@overview/components/display';

type LazyEventCardProps = {
    index: number;
    inView?: boolean;
};

export const LazyEventCard = ({ index, inView = false }: LazyEventCardProps) => {
    //#region Data Fetching
    const { data: eventResponse, isLoading: areEventsLoading } = useAllPublicEventsQuery(
        {
            page_size: 1,
            page: index + 1,
            ordering: 'date_start',
        },
        { skip: !inView }
    );
    const { data: languageOptions, isLoading: areLanguageOptionsLoading } = useGetLanguageSpokenOptionsQuery();

    const prefetchPublicEvent = usePrefetch('getPublicEvent');
    //#endregion

    //#region Processed Data
    const event = (eventResponse as PaginationReturn<RegistrationEventListItem> | undefined)?.results?.[0];
    //#endregion

    return (
        <OverviewEventCard
            loading={!event || areLanguageOptionsLoading || areEventsLoading}
            data={
                event && {
                    ...event,
                    language_spoken: {
                        code:
                            event?.language_spoken?.toString().toLowerCase() === 'en'
                                ? 'us_uk'
                                : event.language_spoken ?? '',
                        label:
                            languageOptions?.find((langOption) => langOption.code === event.language_spoken)?.name ??
                            '',
                    },
                }
            }
            hasUserData={!!event}
            onMouseEnter={() => {
                if (event?.type && event?.id) {
                    prefetchPublicEvent({ type: event?.type, id: event?.id });
                }
            }}
        />
    );
};
